var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "effect 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_8_Nft_Effect"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.5265 36.3488H50.3628C52.7644 36.3488 54.7113 34.4019 54.7113 32.0003C54.7113 29.5987 52.7644 27.6518 50.3628 27.6518H59.5265C61.9281 27.6518 63.875 25.7049 63.875 23.3033C63.875 20.9017 61.9281 18.9548 59.5265 18.9548H33.1722C35.5739 18.9548 37.5207 17.0079 37.5207 14.6063C37.5207 12.2047 35.5739 10.2578 33.1722 10.2578H4.4735C2.07187 10.2579 0.125 12.2048 0.125 14.6064C0.125 17.0081 2.07187 18.9549 4.4735 18.9549H13.6372C11.2356 18.9549 9.28875 20.9018 9.28875 23.3034C9.28875 25.7051 11.2356 27.6519 13.6372 27.6519H4.4735C2.07187 27.6518 0.125 29.5987 0.125 32.0003C0.125 34.4018 2.07187 36.3488 4.4735 36.3488H13.6372C11.2356 36.3488 9.28875 38.2957 9.28875 40.6973C9.28875 43.0989 11.2356 45.0458 13.6372 45.0458H7.97525C5.57362 45.0458 3.62675 46.9927 3.62675 49.3943C3.62675 51.7959 5.57362 53.7428 7.97525 53.7428H53.8645C56.2661 53.7428 58.213 51.7959 58.213 49.3943C58.213 46.9927 56.2661 45.0458 53.8645 45.0458H59.5265C61.9281 45.0458 63.875 43.0989 63.875 40.6973C63.875 38.2957 61.9281 36.3488 59.5265 36.3488Z",
    fill: "#EEE9F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7031 40.2518V23.7477L31.9967 15.4951L46.2903 23.7477V40.2518L31.9967 48.5044L17.7031 40.2518Z",
    fill: "#835BBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.7734 37.4106V26.2287L31.4575 20.6377L41.1416 26.2287V37.4106L31.4575 43.0016L21.7734 37.4106Z",
    fill: "#D4C7F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 691315406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.1473 28.5918H26.8557C26.5598 28.5918 26.3203 28.8459 26.3203 29.1599C26.3203 29.4739 26.5598 29.728 26.8557 29.728H37.1474C37.4433 29.728 37.6828 29.4739 37.6828 29.1599C37.6828 28.8459 37.4433 28.5918 37.1473 28.5918Z",
    fill: "#4E307A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.1473 32.001H26.8557C26.5598 32.001 26.3203 32.2551 26.3203 32.5691C26.3203 32.8831 26.5598 33.1372 26.8557 33.1372H37.1474C37.4433 33.1372 37.6828 32.8831 37.6828 32.5691C37.6828 32.2551 37.4433 32.001 37.1473 32.001Z",
    fill: "#4E307A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.1473 35.4092H26.8557C26.5598 35.4092 26.3203 35.6633 26.3203 35.9773C26.3203 36.2913 26.5598 36.5454 26.8557 36.5454H37.1474C37.4433 36.5454 37.6828 36.2913 37.6828 35.9773C37.6827 35.6633 37.4433 35.4092 37.1473 35.4092Z",
    fill: "#4E307A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M32.5475 12.6698V9.54522C32.5475 9.24525 32.3042 9.00195 32.0042 9.00195C31.7042 9.00195 31.4609 9.24525 31.4609 9.54522V12.6698C31.4609 12.9697 31.7042 13.213 32.0042 13.213C32.3042 13.213 32.5475 12.9696 32.5475 12.6698Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.0042 50.7881C31.7042 50.7881 31.4609 51.0314 31.4609 51.3314V54.4552C31.4609 54.7552 31.7042 54.9984 32.0042 54.9984C32.3042 54.9984 32.5475 54.7552 32.5475 54.4552V51.3314C32.5475 51.0315 32.3042 50.7881 32.0042 50.7881Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.4933 15.7382L45.2841 17.9474C45.072 18.1596 45.072 18.5034 45.2841 18.7156C45.4965 18.928 45.8402 18.9278 46.0524 18.7156L48.2615 16.5065C48.4737 16.2943 48.4737 15.9504 48.2615 15.7382C48.0493 15.5261 47.7055 15.5261 47.4933 15.7382Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.9464 45.2861L15.7373 47.4953C15.5251 47.7074 15.5251 48.0513 15.7373 48.2635C15.9496 48.4758 16.2933 48.4757 16.5055 48.2635L18.7147 46.0543C18.9269 45.8421 18.9269 45.4983 18.7147 45.2861C18.5025 45.0739 18.1586 45.0739 17.9464 45.2861Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M54.4569 31.457H51.3323C51.0324 31.457 50.7891 31.7003 50.7891 32.0003C50.7891 32.3003 51.0324 32.5436 51.3323 32.5436H54.4569C54.7568 32.5436 55.0001 32.3003 55.0001 32.0003C55.0001 31.7003 54.7568 31.457 54.4569 31.457Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.6671 31.4573H9.54327C9.2433 31.4573 9 31.7006 9 32.0005C9 32.3005 9.2433 32.5438 9.54327 32.5438H12.6671C12.9671 32.5438 13.2104 32.3005 13.2104 32.0005C13.2104 31.7006 12.9669 31.4573 12.6671 31.4573Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M46.0524 45.2861C45.8402 45.0739 45.4963 45.0739 45.2841 45.2861C45.072 45.4983 45.072 45.8421 45.2841 46.0543L47.4933 48.2635C47.7056 48.4758 48.0493 48.4757 48.2615 48.2635C48.4737 48.0513 48.4737 47.7074 48.2615 47.4953L46.0524 45.2861Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.7147 18.7156C18.9269 18.5034 18.9269 18.1596 18.7147 17.9474L16.5055 15.7382C16.2933 15.5261 15.9495 15.5261 15.7373 15.7382C15.5251 15.9504 15.5251 16.2943 15.7373 16.5065L17.9464 18.7156C18.1588 18.9278 18.5025 18.9278 18.7147 18.7156Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M32.2725 43.6526L41.9566 38.0614C42.1249 37.9645 42.2283 37.7848 42.2283 37.591V26.4094C42.2283 26.2156 42.125 26.0359 41.9566 25.939L32.2725 20.3478C32.1042 20.2503 31.8975 20.2503 31.7292 20.3478L22.0451 25.939C21.8768 26.0359 21.7734 26.2156 21.7734 26.4094V37.591C21.7734 37.7848 21.8767 37.9645 22.0451 38.0614L31.7292 43.6526C31.8953 43.7489 32.1033 43.7507 32.2725 43.6526ZM22.8601 37.2776V26.7228L32.0009 21.4457L41.1418 26.7228V37.2776L32.0009 42.5547L22.8601 37.2776Z",
    fill: "#190044"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M17.4356 40.723L31.7289 48.9753C31.8948 49.0714 32.1029 49.0734 32.2722 48.9753L46.5655 40.723C46.7338 40.6261 46.8372 40.4464 46.8372 40.2526V23.7487C46.8372 23.5549 46.7339 23.3752 46.5655 23.2783L32.2722 15.0253C32.1039 14.9278 31.8972 14.9278 31.7289 15.0253L17.4356 23.2783C17.2673 23.3752 17.1641 23.5549 17.1641 23.7487V40.2526C17.1641 40.4464 17.2673 40.6261 17.4356 40.723ZM18.2506 24.062L32.0006 16.1231L45.7506 24.062V39.9393L32.0006 47.8775L18.2506 39.9393V24.062Z",
    fill: "#190044"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffect);
export default __webpack_public_path__ + "static/media/effect.d913eb261ddd3e9657e8f9342f3c8aef.svg";
export { ForwardRef as ReactComponent };